export const SEARCH_ITEMS = 'SEARCH/SEARCH_ITEMS';
export const SEARCH_ITEMS_SUCCESS = 'SEARCH/SEARCH_ITEMS_SUCCESS';
export const SEARCH_ITEMS_ERROR = 'SEARCH/SEARCH_ITEMS_ERROR';
export const SET_SEARCH = 'SEARCH/SET_SEARCH';
export const SET_SEARCH_TYPE = 'SEARCH/SET_SEARCH_TYPE';
export const SET_PRODUCT_TYPE = 'SEARCH/SET_PRODUCT_TYPE';
export const RESET_STATE = 'SEARCH/RESET_STATE';